import React, { ReactNode } from 'react'
import { T } from '@transifex/react'
import { TRequestType } from './data'

export const mockRequestTypeLabelMap: Record<TRequestType, ReactNode> = {
  cleaning: <T _str="Cleaning" />,
  change_container_type: <T _str="Change container type" />,
  change_pickup_schee: <T _str="Change pickup scheme" />,
}
